import { ProjectHelper } from '@bimser/common';
import { findMessage } from '@bimser/components';
import { IDictionary, isNullOrUndefined } from '@bimser/core';
import { IDataSource } from '../../../entities/common';
import { IDataSoureInfo, IGetDataFromDataSource } from '../entities/IFormBindedHelpers';
import { Fetch, getValueControl } from '../helper';
import TSHelper from '../helper/TSHelper';
import CompositeDataBoundControl from './CompositeDataBoundControl';
import _get from 'lodash/get';

function usableResponse(response: any) {
	return response?.data?.success && Array.isArray(response.data.result);
}

/**
 * Has scope helpers
 */
export class FormBindedHelpers extends CompositeDataBoundControl {
	serviceUrl: string;
	fetch: Fetch = new Fetch();
	helper: typeof TSHelper = TSHelper;
	constructor() {
		super();
	}

	/**
	 * Collect and evaluate parameters
	 * @param dataSource use current data source
	 */
	getDataSourceInfo(dataSource: IDataSource): IDataSoureInfo {
		const info: IDataSoureInfo = { executable: true, message: '' };
		const parameters: IDictionary<any> = {};
		if (dataSource) {
			//Fill parameters
			for (let i = 0; info.executable && i < dataSource.parameters.length; i++) {
				const p = dataSource.parameters[i];
				let value: any = null;
				if (p.valueModifier === 'fieldSelection' && p.field) {
					const fieldArr = p.field.split('.'),
						controlId = fieldArr.shift();
					value = getValueControl(
						this.__form,
						controlId,
						_get(this.__form, p.field.split('.'), null)
					);
				} else if (p.valueModifier === 'valueEntry') {
					value = p.value;
				}
				if (isNullOrUndefined(value) && p.isRequired) {
					info.executable = false;
					info.message = findMessage.get('101564').replace('0', p.name);
				}
				parameters[p.name] = value;
			}
		}
		return { ...info, parameters: parameters };
	}
	getDataFromDataSource(args: IGetDataFromDataSource) {
		return new Promise<Array<IDictionary<any>>>((resolve, reject) => {
			let { loadOptions, name, force, parameters, projectName, iterator } = args;
			if (typeof iterator !== 'function') {
				reject({ message: 'İnvalid iterator type' });
				return;
			}
			loadOptions = loadOptions || {
				filters: [],
				sorts: [],
				pagination: { skip: 0, take: 100 }
			};
			ProjectHelper.RunPromiseFormService({
				projectName: projectName || this.__form.projectName,
				formName: 'DataSource',
				serviceName: name,
				requestParameters: { ...(parameters || {}), loadOptions },
				requestConfig: {
					headers: {
						'Content-Type': 'application/json; charset=utf-8'
					},
					cache: force
				}
			})
				.then(response => {
					if (usableResponse(response)) {
						const page: number =
							loadOptions.pagination.skip / loadOptions.pagination.take + 1;
						let stoped: boolean = false;
						for (let i = 0; !stoped && i < response.data.result.length; i++) {
							stoped = iterator(response.data.result[i], page);
						}

						if (!response.data.isEndOfSource && !stoped) {
							loadOptions.pagination.skip =
								loadOptions.pagination.skip + loadOptions.pagination.take;
							this.getDataFromDataSource({ ...args, loadOptions })
								.then(data => {
									resolve([...response.data.result, ...data]);
								})
								.catch(ex => {
									reject(ex);
								});
						} else {
							resolve(response.data.result);
						}
					}
				})
				.catch(ex => {
					reject(ex);
				});
		});
	}
}
